import { useEffect, useEffectEvent } from 'react';
import { subscribeConsentChange } from './context.js';

export function useTrackingConsentChange(callback: () => void): void {
  const handler = useEffectEvent(callback);
  useEffect(() => subscribeConsentChange(handler), []);
}
